import React from 'react'
import HeaderHome from '../../components/headerHome/HeaderHome'
import { MiFooter } from '../../components/footer/MiFooter'
import { useContext } from 'react'
import { UsuarioContext } from '../../contexts/UsuarioContext'
import { ContentAvisoLegal } from '../../components/avisoLegal/ContentAvisoLegal'
import './AvisoLegal.css'

export const AvisoLegal = () => {

    const [MenuLateral, setMenuLateral] = useContext(UsuarioContext)
    const closeMenu = () => {
        if (MenuLateral === true) {
            setMenuLateral(false)
        }
    }

    return (
        <div>
            <div className='headerReservarServicio'>
                <HeaderHome />
            </div>
            <div className='legal-advise-body'>
                <ContentAvisoLegal />
            </div>
            <div className='footerReservarServicio'>
                <MiFooter />
            </div>
        </div>
    )
}